import React, { useState, useEffect, useRef } from "react";
import PrimaryButton from "../../elements/primary-button";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses,mobileIs, componentId } from "../../utils/siteUtils";
import { BodyText, FlippedNumber } from "../../elements";
import { scrollToSmoothTryMultipleTimesByDataSourceid } from "../../hooks/scrollToSmooth";
import Videojs from "../video-js";
import moment from 'moment-timezone';
import { gtag } from "../../utils";
import "./style.scss";
import Swiper, { Pagination, Mousewheel, Navigation, Autoplay, EffectCreative, EffectFade } from 'swiper';
Swiper.use([ Pagination, Mousewheel, Navigation, Autoplay, EffectCreative, EffectFade ]);

const HeroSlideV2 = ({ page, lang, rendering, fields }) => {
  const {
    list,
    duration,
    isImageSwiper,
    startTime,
    // endTime
  } = fields;
  const isAR = page?.fields?.rtl?.value;
  const swiper = useRef(null)
  const swiperEl = useRef(null)
  const [currentIndex, setCurrentIndex] = useState(0)
  const [showPage, setShowPage] = useState(true)
  const [isAnimate, setIsAnimate] = useState(false)
  let timer = null;
  const isMobile = mobileIs()
  const resultRef = useRef([])
  const liveStartTIme = new Date(moment(new Date(startTime?.value)).format('YYYY/MM/DD HH:mm:ss'));
  // const liveEndtTIme =  new Date(moment(new Date(endTime?.value)).format('YYYY/MM/DD HH:mm:ss'));
  const nowTIme =  new Date(moment(new Date()).format('YYYY/MM/DD HH:mm:ss'));
   
  const flippers = useRef([]);

  const buildSwiper = () => {
    const options = {
      watchSlidesProgress: true,
      slidesPerView: 1,
      spaceBetween: 0,
      loop: list?.length > 1,
      effect: "creative",
      creativeEffect: {
        prev: {
          shadow: true,
          translate: ["0%", 0, -1]
        },
        next: {
          translate: isAR ? ["-100%", 0, 0] : ["100%", 0, 0]
        },
      },
      speed: 800,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      autoplay: duration?.value ?  duration?.value === 0 ? false : {
        disableOnInteraction: false,
        delay: duration.value ? duration.value * 1000 : 3000,
      } : false,
      on: {
        slideNextTransitionEnd(swiper){
          let realIndex = swiper.realIndex;
          let oldIndex = 0;
          if(realIndex === 0){
            oldIndex = list.length-1
          }else{
            oldIndex = realIndex - 1;
          }
          if(list[oldIndex].fields?.video?.value){
            let dom = document.querySelectorAll('.swiper-slide-'+oldIndex)  
            for(var i=0; i<dom.length; i++) {
              dom[i].children[0].children[0].children[0].currentTime = 0
              dom[i].children[0].children[0].children[0].pause()
            }
          }
        },
        slidePrevTransitionEnd(swiper){
          let realIndex = swiper.realIndex;
          let oldIndex = 0;
          if(realIndex === list.length+1){
            oldIndex = 0
          }else{
            oldIndex = realIndex + 1;
          }
          if(list[oldIndex]?.fields?.video?.value){
            let dom = document.querySelectorAll('.swiper-slide-'+oldIndex)  
            for(var i=0; i<dom.length; i++) {
              dom[i].children[0].children[0].children[0].currentTime = 0
              dom[i].children[0].children[0].children[0].pause()
            }
          }
        },
        slideChangeTransitionStart(swiper) {
          let realIndex = swiper.realIndex   
          let activeIndex = swiper.activeIndex   
          let dom = document.querySelectorAll('.swiper-slide-'+realIndex)  
          if(dom){
            for(var i=0; i<dom.length; i++) {
              if(list[realIndex].fields?.video?.value && list[realIndex].fields?.autoplay?.value){
                dom[i].children[0].children[0].children[0].play()
              }
            }
          }
          if(activeIndex === 0){ //lopp模式下，无法复制video标签，所以手动跳转到非loop Item
            setTimeout(() => {
              swiper.slideToLoop(list.length-1, 0, true);
            },800);
          }
          if(activeIndex === list.length+1){
            setTimeout(() => {
              swiper.slideToLoop(0, 0, true);
            },800);
          }
          if(!isImageSwiper?.value) {
            setCurrentIndex(realIndex)
          }
        }
      }
    }
    swiper.current = new Swiper(swiperEl.current, options);
  }

  useEffect(() => {
    // if( startTime.value == '0001-01-01T00:00:00Z'){
    //   setShowPage(true)
    // }else{
    //   if(parseInt(nowTIme - liveStartTIme) / 1000 > 0 ){
    //     setShowPage(false)
    //   }
    //   if(parseInt(nowTIme - liveStartTIme) / 1000 < 0){
    //     let count =( liveStartTIme - nowTIme )/1000;
    //     timer = setInterval(v=>{
    //       count --;
    //       console.log(`${count}秒后播放`)
    //       if(count == 0 ){
    //         setShowPage(false)
    //         clearInterval(timer)
    //       }
    //     },1000)
    //   }
    // }
    // let agent = navigator.userAgent.toLowerCase()
    // const size = 1 / window.devicePixelRatio;
    // setTimeout((e) => {
    //   let titleDom = document.querySelector('.c-hero-slide-v2_title')
    //   let descDom = document.querySelector('.c-hero-slide-v2_desc')
    //   let btnContentDom = document.querySelector('.button-content')
    //   let numDoms = document.querySelectorAll('.item-num')
    //   let slideDom = document.querySelector('.c-hero-slide-v2_content')
    //   if(agent.indexOf('windows') > 0 && size !== 1 && titleDom && descDom && btnContentDom && numDoms && slideDom) {
    //     titleDom.style.fontSize = 60 * size + 'px'
    //     descDom.style.fontSize = 20 * size + 'px'
    //     btnContentDom.style.marginTop = 45 * size + 'px'
    //     for(let i=0;i<numDoms.length;i++) {
    //       numDoms[i].style.fontSize = 40 * size + 'px'
    //     }
    //     btnContentDom.style.marginTop = 45 * size + 'px'
    //     slideDom.style.top = 120 * size + 'px'
    //     slideDom.style.left = 120 * size + 'px'
    //   }
    // })
    setTimeout(function(){
      buildSwiper()
      setIsAnimate(true)
    },100)

    setTimeout(function(){
      playVideo()
    },1000)

    return () => {
      // if (swiper?.current) {
      //   swiper.current.destroy(true, true);
      //   swiper.current = null;
      // }
    };
    
  },[])

  const playVideo = () => {
    if(resultRef.current && resultRef.current.length > 0) {
      if( resultRef.current[0] && list[0].fields?.autoplay?.value){
        resultRef.current[0].player.play(0)
      }
    }
  }

  const clickTab = (item) => {
    gtag('event', 'Component_info', {
      'component_name': 'HeroSlideV2',
      'page_title': page?.name
    });
    let id = `{${item?.anchorPoint?.id?.toUpperCase()}}`;
    scrollToSmoothTryMultipleTimesByDataSourceid(id);
  }
	const rootId = componentId(rendering);
  const rootClasses = classNames("c-hero-slide-v2", getOverallSettingsClasses(fields));
  return (
    <>
		{showPage && 
    <div className={rootClasses} datasourceid={rendering.dataSource} id={rootId}>
      <div className="c-hero-slide-v2_swiper swiper" ref={swiperEl}>
				<div className="swiper-wrapper">
					{list && list.map((item, i) => (
						<div className={classNames('swiper-slide grid', 'swiper-slide'+'-'+i , item?.fields?.autoplay?.value ? 'autoplay' : '', 'show-poster')} key={i}>
              {item?.fields?.m_image?.value && !item?.fields?.video?.value && isMobile && <div className="c-hero-slide-v2__background_image slide-inner" style={{ backgroundImage: `url(${item?.fields?.m_image?.value?.src})` }} ></div>}
              {item?.fields?.pc_image?.value && !item?.fields?.video?.value && !isMobile && <div className="c-hero-slide-v2__background_image slide-inner" style={{ backgroundImage: `url(${item?.fields?.pc_image?.value?.src})` }} ></div>}
              {item?.fields?.m_video?.value && isMobile && <Videojs
                ref={e => resultRef.current.push(e)}
                {...{
                  sources: [
                    {
                      src: item?.fields?.m_video?.value?.src,
                      type: item?.fields?.m_video?.value?.mimeType
                    }
                  ],
                  controls: false,
                  autoplay: false,
                  loop: true,
                  muted: true,
                  poster: (item?.fields?.m_image?.value && !item?.fields?.autoplay?.value) ? item?.fields?.m_image?.value?.src : ""
                }}
              />}
              {item?.fields?.pc_video?.value && !isMobile && <Videojs
                ref={e => resultRef.current.push(e)}
                {...{
                  sources: [
                    {
                      src: item?.fields?.pc_video?.value?.src,
                      type: item?.fields?.pc_video?.value?.mimeType
                    }
                  ],
                  controls: false,
                  autoplay: false,
                  loop: true,
                  muted: true,
                  poster: (item?.fields?.pc_image?.value && !item?.fields?.autoplay?.value) ? item?.fields?.pc_image?.value?.src : ""
                }}
              />}
              {list[currentIndex]?.fields?.performanceList && list[currentIndex]?.fields?.performanceList.length > 0 && list[currentIndex]?.fields?.autoplay.value && <div className="mask"></div>}
						</div>
					))}
				</div>
        {list?.length > 1 && <div className="swiper-pagination"></div>}
			</div>
      {/* 文案 */}
      <div className={["c-hero-slide-v2_content", list[currentIndex]?.fields?.position?.fields?.key?.value === 'center' ? 'center' : 'left'].join(' ')}>
        <BodyText html={ isMobile ? list[currentIndex]?.fields?.mTitle?.value : list[currentIndex]?.fields?.pcTitle?.value } className={["c-hero-slide-v2_title", isAnimate ? 'active' : ''].join(' ')} />
        <BodyText html={ isMobile ? list[currentIndex]?.fields?.mSub?.value : list[currentIndex]?.fields?.pcSub?.value } className={["c-hero-slide-v2_desc", isAnimate ? 'active' : ''].join(' ')} />
        <div className={["button-content", isAnimate ? 'active' : ''].join(' ')}>
          {list[currentIndex]?.fields?.buttonList && list[currentIndex]?.fields?.buttonList?.length > 0 && list[currentIndex]?.fields?.buttonList.map((option, i) => {
              return option.fields?.buttonText?.value && <div className="primary-button-in" key={i} onClick={e => clickTab(option.fields)}>
              <PrimaryButton {...(option.fields)} />
            </div>
          })}
        </div>
      </div>

      {/* 数值 */}
    
      <div className={["performance-content", isAnimate ? 'animate' : '' , list[currentIndex]?.fields?.position?.fields?.key?.value === 'center' ? 'center' : 'left'].join(' ')}>
        {list && list.map((firstItem, i) =>(
          <div key={i}>
            { currentIndex == i &&
              <div className="performance-content-item">
              {firstItem?.fields?.performanceList.map((item, j) => {
                return <div className={["performance-item", j%2 === 0 ? 'only' : 'reve-only', j > 1 ? 'mar' : ''].join(' ')} key={j}>
                  <div className={["item-top", item?.fields?.unit_is_left?.value ? 'active' : ''].join(' ')}>
                    <FlippedNumber number={item?.fields?.num?.value} ref={e=> flippers[j] = e} index={i} activeIndex ={currentIndex}/>
                    <RichText tag="div" className="item-unit" field={item?.fields?.unit} />
                  </div>
                  <RichText tag="div" className="item-desc" field={item?.fields?.desc} />
                </div>
              })}
              </div>
            }
          </div>
        ))}
      </div>
    </div>
    }
    </>
  );
};

export default HeroSlideV2;
